import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./components/translation/en.json";
import th from "./components/translation/th.json";
import es from "./components/translation/es.json";
import id from "./components/translation/id.json";
import ar from "./components/translation/ar.json";
import vi from "./components/translation/vi.json";
import ms from "./components/translation/ms.json";
import fil from "./components/translation/fil.json";
import ko from "./components/translation/ko.json";
import ja from "./components/translation/ja.json";
import zh from "./components/translation/zh.json";
import hi from "./components/translation/hi.json";
import pt from "./components/translation/pt.json";
import fr from "./components/translation/fr.json";
import de from "./components/translation/de.json";
import { getStoredLanguage } from "./utils/getLanguage";

const lng = getStoredLanguage();

// Rewrites any legacy HealJai product name in translated strings to "Astria".
// Applied here so individual call sites don't each have to remember.
const brandPostProcessor = {
  type: "postProcessor" as const,
  name: "brand",
  process(value: string) {
    return value
      .replace(/heal\s*jai/gi, "Astria")
      .replace(/ฮีลใจ/g, "Astria")
      .replace(/ฮีลเจย์/g, "Astria");
  },
};

i18n.use(brandPostProcessor).use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
    es: { translation: es },
    id: { translation: id },
    ar: { translation: ar },
    vi: { translation: vi },
    ms: { translation: ms },
    fil: { translation: fil },
    ko: { translation: ko },
    ja: { translation: ja },
    zh: { translation: zh },
    hi: { translation: hi },
    pt: { translation: pt },
    fr: { translation: fr },
    de: { translation: de },
  },

  lng,
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },

  postProcess: ["brand"],
});

// Keep <html lang> in step with the UI language (screen readers, hyphenation,
// browser translate prompts). Direction is deliberately left alone: only the
// screens that were built for RTL set their own dir.
const syncDocumentLang = (language: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
  }
};
syncDocumentLang(i18n.language);
i18n.on("languageChanged", syncDocumentLang);

export default i18n;
